import { base64ToArrayBuffer } from '../../shared/utils';
import { useLazyFetchPdfInvoiceQuery } from '../service';

export default function useDownloadPdfInvoice() {
    const [fetchPdfInvoice, { isLoading: isDownloadingPdfInvoice }] = useLazyFetchPdfInvoiceQuery();

    const downloadPdfInvoice = async (invoiceNumber: number) => {
        try {
            const response = await fetchPdfInvoice({ invoiceNumber }).unwrap();

            const blob = new Blob([base64ToArrayBuffer(response.pdf)], { type: 'application/pdf' });

            // MS Edge and IE don't allow using a blob object directly as link href, instead it is necessary to use msSaveOrOpenBlob
            // @ts-ignore
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                // @ts-ignore
                window.navigator.msSaveOrOpenBlob(blob);
            } else {
                // For other browsers: create a link pointing to the ObjectURL containing the blob.
                const objUrl = window.URL.createObjectURL(blob);

                let link = document.createElement('a');
                link.href = objUrl;
                link.download = `invoice_${invoiceNumber}.pdf`;
                link.click();

                // For Firefox it is necessary to delay revoking the ObjectURL.
                setTimeout(() => {
                    window.URL.revokeObjectURL(objUrl);
                }, 250);
            }
        } catch (error) {}
    };

    return {
        downloadPdfInvoice,
        isDownloadingPdfInvoice,
    };
}
